import React, {useEffect, useState} from 'react';
import {
    Alert,
    Box,
    Button,
    Grid,
    Modal,
    ModalActions,
    ModalContent,
    ModalTitle,
    Typography,
    useToastProvider
} from "@deere/fuel-react";
import {SEND_REMINDER_DESCRIPTION} from "../Constants";
import {toCapitalize} from "../utils";
import WarningIcon from "@material-ui/icons/Warning";
import {useAuthConfig} from "../helper";
import {Loading} from "../Loading";

export const SendReminderModal = ({campaignId, onSave}) => {
    const {enqueueToast} = useToastProvider();
    let authAxios = useAuthConfig();
    const [open, setOpen] = useState(false);
    const [isAnyInvalid, setIsAnyInvalid] = useState(false);
    const [stakeholdersData, setStakeholdersData] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    const handleClickOpen = () => {
        setOpen(true);
        fetchStakeholdersData();
    };

    const handleClose = () => {
        setOpen(false);
    };

    const handleSave = () => {
        setOpen(false);
        onSave()
    }

    const getStakeholdersList = async () => {
        setIsLoading(true)
        try {
            return await authAxios.get(`/campaign/reminder/${campaignId}`)
        } catch (e) {
            console.error(e);
            enqueueToast({
                variant: "error",
                title: "Error fetching pending users list",
                isCloseable: false
            });
        }
    };

    const fetchStakeholdersData = () => {
        getStakeholdersList().then(res => {
            const reminderData = res.data.campaignStakeholder;

            setStakeholdersData(reminderData);
            const validArr = reminderData && reminderData.map(item => item.valid)
            setIsAnyInvalid(!validArr.every(Boolean))
            setIsLoading(false)
        }).catch((error) => {
            setIsLoading(false)
            console.log(error)
        });
    }

    useEffect(() => {
        return () => {
            setStakeholdersData([]);
        } // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <>
            <Button variant="text" style={{padding: "0"}} onClick={handleClickOpen}>
                Send Reminder
            </Button>
            <Modal
                open={open}
                onClose={handleClose}
                aria-labelledby="alert-Modal-title"
                aria-describedby="alert-Modal-description"
                maxWidth="sm"
                fullWidth={true}
            >
                <ModalTitle onClose={handleClose} id="alert-Modal-title">
                    Send Reminder Email
                </ModalTitle>
                <ModalContent>
                    {isLoading && (
                        <Loading/>
                    )}
                    {!isLoading && (
                        <Grid container alignItems="center" spacing={2}>
                            {isAnyInvalid && (
                                <Grid item xs={12}>
                                    <Box pb={1} pt={0}>
                                        <Alert variant="warning">
                                            Invalid UserId(s) will not receive a reminder email
                                        </Alert>
                                    </Box>
                                </Grid>
                            )}
                            <Grid item xs={12}>
                                <Typography size="md" component="p" gutterBottom>
                                    {SEND_REMINDER_DESCRIPTION}
                                </Typography>
                            </Grid>
                            <Grid item xs={12}>
                                <Box m={1}>
                                    <ul>
                                        {stakeholdersData.length > 0 && stakeholdersData.map((reminder, index) => {
                                            const name = `${toCapitalize(reminder.user.lastName)}, ${toCapitalize(reminder.user.firstName)} - ${reminder.user.racfID}`
                                            const rolesArr = reminder.roles && reminder.roles.map(item => item.description)
                                            const unitsArr = reminder.units && reminder.units.map(item => Object.keys(item).length > 0 ? `${item.description} - ${item.id}` : '')
                                            return (
                                                <li key={index}>
                                                    <Box display="inline" pr={1}>
                                                        <Typography size="sm" fontWeight="semibold" gutterBottom
                                                                    display="inline">
                                                            {!reminder.valid && (
                                                                <WarningIcon style={{fill: "#fab64c"}}/>
                                                            )}
                                                            {name}
                                                        </Typography>
                                                    </Box>
                                                    <Typography size="sm" color="tertiary"
                                                                display="inline">
                                                        &nbsp; ({rolesArr.join(', ')})
                                                    </Typography>
                                                    <br/>
                                                    <Typography size="sm" color="tertiary">
                                                        {unitsArr && unitsArr.join(', ')}
                                                    </Typography>
                                                </li>
                                            )
                                        })
                                        }
                                    </ul>
                                </Box>
                            </Grid>
                        </Grid>
                    )}
                </ModalContent>
                <ModalActions>
                    <Button onClick={handleClose} variant="secondary">
                        Cancel
                    </Button>
                    <Button onClick={handleSave} variant="primary">
                        Send Reminder
                    </Button>
                </ModalActions>
            </Modal>
        </>
    );
};
